export default "__VITE_ASSET__C9S8304R__"